<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-card>
          <div class="shadow-none">
            <div
              class="d-flex justify-space-between flex-wrap align-center"
            >
              <v-card-title>
                Distribution Packages ({{ distributionPackages.length }})
              </v-card-title>
              <div class="pa-2">
                <v-btn
                  :disabled="loading"
                  color="primary"
                  @click="newPackage()"
                >
                  <i class="mdi mdi-plus p-r-5" />
                  add
                </v-btn>
                <v-btn
                  outlined
                  class="ma-2"
                  :loading="reportLoading"
                  @click="exportXLS()"
                >
                  <i class="mdi mdi-download p-r-5" />
                  Export
                </v-btn>
              </div>
            </div>
          </div>
          <v-card-text>
            <v-data-table
              hide-default-footer
              :headers="headers"
              :items="distributionPackages"
              class="eg-table-td-py-md text--pointer"
              disable-pagination
              @click:row="goToDetails"
            >
              <template v-slot:item.id="{item}">
                {{ item.id }}
              </template>
              <template v-slot:item.createTime="{item}">
                {{ moment.utc(item.createTime).format('D MMM YYYY') }}
              </template>
              <template v-slot:item.name="{item}">
                <h6 class="ma-0 font-weight-medium">
                  {{ item.name }}
                </h6>
              </template>
              <template v-slot:item.mtPrefix="{item}">
                <span class="grey--text">
                  {{ item.mtSuffix }}
                </span>
              </template>
              <template v-slot:item.action="{item}">
                <v-menu
                  left
                  bottom
                >
                  <template v-slot:activator="{on}">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon
                        class=""
                      >
                        mdi-dots-horizontal
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click.stop="openRemoveDialog(item)">
                      <v-icon
                        class="text-body-1 mr-2"
                      >
                        mdi-trash-can
                      </v-icon>
                      <v-list-item-title>
                        Delete
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
    <!-- Add Form  -->
    <v-dialog
      v-model="newPackageDialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">New Distribution Package</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                Please provide a name for your distribution package (at least three characters):
                <v-text-field
                  v-model="newDistribPack.name"
                  label="Name*"
                  :counter="255"
                  :rules="rules.nameRules"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="newDistribPack.mtPrefix"
                  label="MT URL prefix"
                  placeholder="https://"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="newDistribPack.mtPrerollPrefix"
                  label="MT pre-roll URL prefix"
                  placeholder="https://"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="newPackageDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            :disabled="loading || !isFormValid"
            @click="saveNewDistribPackage()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Remove Dialog -->
    <v-dialog
      v-model="removeDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Delete distribution package?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to delete the distribution package "{{ deletedDistribPack.name }}"?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="removeDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="error"
            @click="deleteDistribPack()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { processDistributionPackage } from '@/store/converters'

  export default {
    metaInfo: {
      title: 'Distribution Packages',
    },
    data () {
      return {
        headers: [
          {
            text: 'Id',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          { text: 'Created', value: 'createTime' },
          { text: 'Name', value: 'name' },
          { text: 'NP Channels', value: 'playoutChannelCount' },
          { text: '3P Channels', value: 'thirdPartyChannelCount' },
          { text: 'MT Prefix', value: 'mtPrefix', sortable: false },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        distributionPackages: [],
        newPackageDialog: false,
        newDistribPack: {
          name: '',
          mtPrefix: '',
          mtPrerollPrefix: '',
        },
        rules: {
          nameRules: [
            (v) => !!v || 'Name is required',
            (v) => (v && v.length <= 1024) || 'Name must be less than 1024 characters',
          ],
        },
        deletedDistribPack: {},
        removeDialog: false,
        reportLoading: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isFormValid () {
        if (!(this.newDistribPack.name.length >= 3 && this.newDistribPack.name.length <= 255)) {
          return false
        }
        return true
      },
    },
    created () {
      this.getDistributionPackages()
    },
    methods: {
      getDistributionPackages () {
        this.$store.commit('setPageLoader')

        const args = {
        }
        const distribPackReq = this.$store.dispatch('distributionPackages', args)

        const distribPackStatReq = this.$store.dispatch('distributionPackagesStat')

        return Promise.all([distribPackReq, distribPackStatReq])
          .then((res) => {
            const packages = res[0]
            const processed = packages.map((d) => processDistributionPackage(d))
            const index = {}
            for (let i = 0; i < processed.length; i += 1) {
              const parts = processed[i].mtPrefix.split('/')
              if (parts.length > 2) {
                processed[i].mtSuffix = parts[parts.length - 1] !== '' ? parts[parts.length - 1] : parts[parts.length - 2]
                processed[i].mtSuffix = '../' + processed[i].mtSuffix
              }
              index[processed[i].id] = i
            }

            const stat = res[1] || []
            for (let i = 0; i < stat.length; i += 1) {
              const s = stat[i]
              // eslint-disable-next-line no-prototype-builtins
              if (index.hasOwnProperty(s.DistributionPackageId)) {
                processed[index[s.DistributionPackageId]].playoutChannelCount = s.PlayoutChannelCount || 0
                processed[index[s.DistributionPackageId]].thirdPartyChannelCount = s.ThirdPartyChannelCount || 0
              }
            }

            this.distributionPackages = processed
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'ChannelsPage' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      goToDetails (distribution) {
        this.$router.push({
          name: 'Distribution',
          params: {
            distribution_id: distribution.id,
          },
        })
      },
      newPackage () {
        this.newPackageDialog = true
      },
      saveNewDistribPackage () {
        if (!this.isFormValid) return

        this.$store.commit('setPageLoader')
        const distribPack = {
          name: this.newDistribPack.name,
          mt_prefix: this.newDistribPack.mtPrefix,
          mt_preroll_prefix: this.newDistribPack.mtPrerollPrefix,
        }

        this.$store.dispatch('createDistributionPackage', distribPack)
          .then((pack) => {
            this.$store.commit('showSnackbar', {
              text: 'The distribution package has been successfully created',
              timeout: 3000,
              color: 'success',
            })
            this.goToDetails(pack)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.newPackageDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      openRemoveDialog (pack) {
        this.deletedDistribPack = pack
        this.removeDialog = true
      },
      deleteDistribPack () {
        if (!this.deletedDistribPack.id) return

        this.$store.commit('setPageLoader')
        this.$store.dispatch('deleteDistributionPackage', this.deletedDistribPack.id)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The distribution package has been successfully removed',
              timeout: 6000,
              color: 'success',
            })
            this.getDistributionPackages()
            this.deletedDistribPack = {}
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.removeDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      exportXLS () {
        this.reportLoading = true
        this.$store.dispatch('exportAllDistributions')
          .then((response) => {
            const blob = new Blob([response.data], { type: response.data.type })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'Playout Distributions'
            link.click()
            URL.revokeObjectURL(link.href)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.reportLoading = false
          })
      },
    },
  }
</script>

<style>
@media (min-width: 1200px) {
  .container {
    max-width: 1320px !important;
  }
}
</style>
